import counsellorsManagementDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  }
};

const counsellorsReducer = counsellorsManagementDispatcher(initialState, {
  [counsellorsManagementDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  }),

  [counsellorsManagementDispatcher.getDataBookingSuccess]: (state, payload) => {
    return { ...state, timeBooking: payload.timeBooking };
  },
  [counsellorsManagementDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value
  }),
  [counsellorsManagementDispatcher.resetData]: (state, _) => ({
    ...initialState
  })
});

export default counsellorsReducer;
